import styled from "styled-components";
import { palette } from "styled-theme";

const PatientDetailsWrapper = styled.div`
  display: flex;
  align-items: flex-start;
  height: 145px;

  .attributes {
    @media (max-width: 1100px) {
      display: none;
    }
    margin: 18px 20px 0px 0px;
    padding: 0 20px;
    border-right: 1px solid ${palette("border", 0)};
    align-self: flex-start;
  }
  .bgImage {
    @media (max-width: 850px) {
      display: none;
    }
  }
  .dynamic_item_button {
    border: 1px solid ${palette("primary", 0)};
  }
`;

export default PatientDetailsWrapper;
